import assign from "lodash/fp/assign";
import startCase from "lodash/fp/startCase";
import map from "lodash/fp/map";
import moment from "moment";
import constants from "../../core/constants";
import isNil from "lodash/fp/isNil";
import { getTime } from "../../core/utils";
class BackupSchedulesPageTransform {
  constructor($injector, Events) {
    "ngInject";
    this.City = $injector.get("City");
    this.onSelectCityEvent = Events.getSelectCityEvent();
    Events.on(this.onSelectCityEvent, this.getSelectCity.bind(this));

    const formatTimeWithDiffTimezone = (value) => {
      const localTimezone =
        Math.abs(new Date().getTimezoneOffset()) * constants.fromMinToMilli;

      // Difference between local timezone and route city timezone
      const diffTimezone = Math.abs(this.cityTimezone - localTimezone);

      // Get Selected Time with respect of timezone
      const valueWithDiffTimezone =
        localTimezone > this.cityTimezone
          ? getTime(value) - diffTimezone
          : getTime(value) + diffTimezone;

      /* Local timezone and route city timezone are the same, will send selected value
      // Local timezone and route city timezone aren't the same, will respect local timezone
      // handle if difference timezone is negative so need to add 24 hours
      */
      const formattedValue =
        this.cityTimezone === localTimezone
          ? getTime(value)
          : valueWithDiffTimezone < 0
          ? valueWithDiffTimezone + constants.fromDayToMilli
          : valueWithDiffTimezone < constants.fromDayToMilli
          ? valueWithDiffTimezone
          : valueWithDiffTimezone - constants.fromDayToMilli;

      return formattedValue;
    };

    this.item = {
      title: "Backup Schedule",
      state: "backupschedule",
      name: "backupschedule",
    };

    this.fields = [
      { title: "Captain", name: "captain" },
      { title: "Category", name: "category_name" },
      { title: "Bustype", name: "bus_type" },
      { title: "Backup Station", name: "station" },
      { title: "Start Time", name: "start_time" },
      { title: "End Time", name: "end_time" },
    ];

    this.filters = [
      {
        name: "captain",
        title: "Captain",
        icon: "person",
        resource: "Captain",
        hasExact: true,
        exactFields: ["name", "phone"],
        size: 25,
      },
      {
        name: "bus_type",
        title: "Bustype",
        icon: "directions_bus",
        resource: "Bustype",
      },
      {
        name: "station",
        title: "Backup Station",
        icon: "directions_bus",
        resource: "Station",
      },
    ];

    this.addOptions = {
      title: "Add New Backup Schedule",
      icon: "add",
      fields: [
        {
          resource: "City",
          name: "city",
          title: "City",
          isResource: true,
          isRequired: true,
          onChange: this.onSelectCityEvent,
        },
        {
          resource: "Captain",
          name: "captain",
          title: "Captain",
          isResource: true,
          isRequired: false,
          hasExact: true,
          exactFields: ["name", "phone"],
        },
        {
          resource: "Bustype",
          name: "bus_type",
          title: "Bustype",
          isResource: true,
          isRequired: true,
        },
        {
          resource: "Bus",
          name: "bus",
          title: "Bus",
          isResource: true,
          isRequired: true,
        },
        {
          name: "ride_category",
          title: "Ride Category",
          list: "rideCategoryList",
          isRequired: true,
        },
        {
          resource: "Station",
          name: "station",
          title: "Backup Station",
          isResource: true,
          IsRequired: true,
        },
        {
          name: "start_time",
          title: "Start Time",
          icon: "date_range",
          time: true,
          isRequired: true,
          formatter: formatTimeWithDiffTimezone,
        },
        {
          name: "end_time",
          title: "End Time",
          icon: "date_range",
          time: true,
          isRequired: true,
          formatter: formatTimeWithDiffTimezone,
        },
        {
          name: "weekdays",
          title: "Week Days",
          icon: "date_range",
          isScheduleDays: true,
          value: [],
        },
      ],
    };
  }

  getSelectCity(selected) {
    this.cityId = selected._id;
    this.City.get(this.cityId).$promise.then((response) => {
      this.cityTimezone = response.timezone;
    });
  }

  justify(data) {
    const format = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.category_name = item.ride_category
        ? `${startCase(item.ride_category.ride_type)} ${startCase(
            item.ride_category.service_type
          )}`
        : "";

      if (!isNil(item.city.timezone)) {
        const itemTimezoneDiff = item.city.timezone;

        item.start_time = moment(item.start_time - itemTimezoneDiff).format(
          constants.timeFormat
        );
        item.end_time = moment(item.end_time - itemTimezoneDiff).format(
          constants.timeFormat
        );
      }

      return item;
    };

    return map(format)(data);
  }
}

export default BackupSchedulesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/backupSchedules/backupSchedules.transforms.js